import styled from "@emotion/styled";
import { timelineColors } from "../../theme/config";

export const ContentWrapper = styled.div`
  width: 300px;
  border-left: 1px solid ${timelineColors.border};
  overflow-y: scroll;
  max-height: 100%;
  background-color: #fff;
`;

export const InnerWrapper = styled.div`
  position: relative;
  padding: 15px 20px;

  &:first-of-type > div {
    white-space: nowrap;
  }
  div > span {
    font-size: 12px !important;
    font-weight: 500;
  }
`;

export const TabsWrapper = styled.div`
  margin-top: 5px;
  ul > li > button {
    font-size: 12px !important;
    font-weight: 600 !important;
  }
`;

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const SwitchWrapper = styled.div``;

export const ButtonsWrapper = styled.div`
  text-align: right;
  gap: 5px;
  display: flex;
`;
